export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_19.d1d56729.png";